// @flow
import React from 'react';
import classnames from 'classnames';

import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';
import Image from 'Components/frameworks/image/Image.jsx';

import { themes } from './Badge.themes';

export type BadgeProps = {
  alt?: string,
  className?: string,
  color?: Colors,
  colorBg?: Colors,
  colorBorder?: Colors,
  hasShadow?: boolean,
  iconName?: IconName,
  iconSize?: string,
  imageSrc?: string,
  label?: string,
  size?: number | string,
  theme?: string,
  variant?: 'diamond' | 'pill',
};

export function Badge(props: BadgeProps) {
  const {
    alt,
    className,
    iconName,
    iconSize,
    imageSrc,
    label,
    size = 50,
    theme = 'default',
  } = props;

  if (!iconName && !imageSrc && !label) return null;

  const { thIcon, thIconSize, thImage, thLabel, thLabelStyle, thRoot } = themes[theme](props);

  const styles = { width: size, height: size };
  const imageSize = {
    w: size,
    h: size,
  };

  return (
    <div className={classnames(className, thRoot)} style={styles}>
      {!!imageSrc && (
        <div className={thImage}>
          <Image altMsg={alt} forceImage imageUrl={imageSrc} mandatoryWidthAndHeight={imageSize} />
        </div>
      )}
      {!!iconName && (
        <div className={thIcon}>
          <Icon alt={alt} name={iconName} title={alt} width={iconSize || thIconSize} />
        </div>
      )}
      {!!label && (
        <div className={thLabel} style={thLabelStyle}>
          {label}
        </div>
      )}
    </div>
  );
}
